// extracted by mini-css-extract-plugin
export var container = "_8u-0";
export var fallback = "_8u-5";
export var fallbackIcon = "_8u-6";
export var hidden = "_8u-2";
export var image = "_8u-3";
export var loaded = "_8u-4";
export var placeholder = "_8u-1";